import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.el.querySelector('.js-alert-close').addEventListener('click', () => {
            document.querySelector('html').classList.add('hide-alert');
            // add cookie to remember the state for a week
            document.cookie = 'hide-alert=true; expires=' + new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toUTCString();
        });
    }
}
